import React from 'react';

const ErrorMessage = (props) => {
    const { message } = props;
    return (
        message ? <div className="field-validation-error" role="alert">{message}</div> : null
    );
}
export default ErrorMessage;